module.exports = __webpack_public_path__ + "img/icons_20.0e92b501.svg";